export const manifest = {
  screens: {
    scr_blr1lu: { name: "Banner Ad (Hook)", route: "/", state: {"step":0}, position: {"x":160,"y":220} },
    scr_kxlcid: { name: "Flip Reveal", route: "/", state: {"step":1}, position: {"x":5760,"y":220} },
    scr_x7dpr9: { name: "Problem Mirror", route: "/", state: {"step":2}, position: {"x":1560,"y":220} },
    scr_4nywvk: { name: "Self-Rating", route: "/", state: {"step":3}, position: {"x":2960,"y":220} },
    scr_uahddu: { name: "Why not lower?", route: "/", state: {"step":4}, position: {"x":4360,"y":220} },
    scr_a4xshj: { name: "Definition", route: "/", state: {"step":5}, position: {"x":7160,"y":220} },
    scr_kyrer2: { name: "Data", route: "/", state: {"step":6}, position: {"x":8560,"y":220} },
    scr_momm3p: { name: "Brand Bridge", route: "/", state: {"step":7}, position: {"x":9960,"y":220} },
    scr_eqb3xc: { name: "CTA", route: "/", state: {"step":8}, position: {"x":11360,"y":220} },
  },
  sections: {
    sec_gxv207: { name: "CHE Awareness Journey", x: 0, y: 0, width: 14120, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_gxv207", children: [
      { kind: "screen", id: "scr_blr1lu" },
      { kind: "screen", id: "scr_x7dpr9" },
      { kind: "screen", id: "scr_4nywvk" },
      { kind: "screen", id: "scr_uahddu" },
      { kind: "screen", id: "scr_kxlcid" },
      { kind: "screen", id: "scr_a4xshj" },
      { kind: "screen", id: "scr_kyrer2" },
      { kind: "screen", id: "scr_momm3p" },
      { kind: "screen", id: "scr_eqb3xc" },
      { kind: "screen", id: "scr_xyl544" },
    ] },
  ],
}
